
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {TipoEntitaOrganizzativa} from './tipoentitaorganizzativa.model';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {Gerarchia} from '../../+anagrafica/gerarchia/gerarchia.model';
import {TipoGerarchia} from '../tipogerarchia/tipogerarchia.model';

@Injectable()
export class TipoEntitaOrganizzativaService extends CommonService<TipoEntitaOrganizzativa> {

  public static ROUTE = 'tipoentitaorganizzativa';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): TipoEntitaOrganizzativa {
    return JsonBaseBuilder.jsonToTipoEntitaOrganizzativa(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return TipoEntitaOrganizzativaService.ROUTE;
  }

  public getTable(items: TipoEntitaOrganizzativa[]): Table {
    return Table.buildBaseTable(TipoEntitaOrganizzativa.getTableKeys(), items);
  }

  public existingDescr(descr: string, entity: TipoEntitaOrganizzativa): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingSigla(sigla: string, entity: TipoEntitaOrganizzativa): Observable<boolean> {
    return this.getBoolean('/existingsigla', new HttpParams()
      .set('sigla', sigla)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  /**
   * I tipi entita organizzativa che posso agganciare sotto il nodo gerarchia.
   */
  public forChild(gerarchia: Gerarchia, tipoGerarchia: TipoGerarchia, inizio, fine): Observable<TipoEntitaOrganizzativa[]> {
    let params = new HttpParams();
    if (gerarchia) {
      params = new HttpParams().set('gerarchiaId', '' + gerarchia.getId());
    } else {
      params = new HttpParams().set('tipoGerarchiaId', '' + tipoGerarchia.getId());
    }
    return this.getArray('/forchild', params).pipe(map( (items) => {
      return items;
    }));
  }

  /**
   * I tipi entita organizzativa che possono sostutuire il padre del nodo gerarchia.
   */
  public forParent(gerarchia: Gerarchia, inizio, fine): Observable<TipoEntitaOrganizzativa[]> {
    const params = new HttpParams().set('gerarchiaId', '' + gerarchia.getId());
    return this.getArray('/forparent', params).pipe(map( (items) => {
      return items;
    }));
  }



}
